import { render, staticRenderFns } from "./NotificationItemCard.vue?vue&type=template&id=40c1aaa9&scoped=true&"
import script from "./NotificationItemCard.vue?vue&type=script&lang=js&"
export * from "./NotificationItemCard.vue?vue&type=script&lang=js&"
import style0 from "./NotificationItemCard.vue?vue&type=style&index=0&id=40c1aaa9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c1aaa9",
  null
  
)

export default component.exports